const KEYS = {
    LOCATION: "QUl6YVN5QU5zUUk1NVp5WVhPeU05MnZwcWlHN1lGczhoejNCVDlF",
  }
  export default KEYS
  